/**
 * Textos alinhados à matriz LGPD (docs/lgpd-account-deletion-matrix.md).
 * Manter em sync com privacy-policy e privacy-page (checklist copy-sync no plano).
 */
export const ACCOUNT_DELETION_CONFIRMATION_PHRASE = "EXCLUIR_CONTA_AKIHUB" as const;

export const accountDeletionPublicCopy = {
  pageTitle: "Exclusão de conta e dados — akihub",
  intro:
    "Esta página descreve como solicitar a exclusão da sua conta no **akihub** e o que acontece aos seus dados, em linha com a LGPD e com as exigências da Google Play.",
  developerLine:
    "Responsável: utilize o nome do programador e a entidade jurídica exatamente como na ficha da loja (Play Store / App Store).",

  stepsTitle: "Como pedir a exclusão da conta",
  steps: [
    "Abra o site **www.akihub.com.br** ou o aplicativo akihub no telefone.",
    "Inicie sessão na conta que deseja encerrar.",
    "Vá a **Configurações** → **Privacidade e dados** → na secção **Gerenciamento de Dados**, **Excluir conta**. No **site**, abra primeiro o **menu** (ícone no canto superior) para ver **Configurações**; na **app**, use o **menu** ou o **perfil** conforme o dispositivo.",
    "Confirme a identidade: se tiver senha, introduza-a; se entrar só com Google ou Apple, digite a frase de confirmação indicada neste dispositivo.",
    "Aguarde o processamento. Pode receber um e-mail de confirmação; o prazo máximo é de 2 dias úteis.",
  ],

  blocksTitle: "O que acontece aos seus dados",
  deletedTitle: "1. O que eliminamos na nossa infraestrutura",
  deletedBullets: [
    "Sessões e tokens de atualização (logout em todos os dispositivos).",
    "Carrinho, favoritos, notificações in-app e registos de dispositivo para push, quando aplicável.",
    "Dados de perfil e conteúdos que não tenham obrigação legal de permanecer.",
  ],

  anonymizedTitle: "2. O que anonimizamos (deixa de o identificar)",
  anonymizedBullets: [
    "Em **pedidos e envios** antigos, substituímos nome, e-mail, morada e telefone por valores genéricos ou identificadores internos, mantendo o mínimo necessário para obrigações fiscais, anti-fraude ou resolução de litígios.",
    "Em dispositivos de outro utilizador, o seu nome pode aparecer como “Utilizador removido” onde antes constava o seu perfil.",
  ],

  retainedTitle: "3. Conservação legal e terceiros (Stripe)",
  retainedBullets: [
    "Registos financeiros e fiscais podem permanecer pelo tempo exigido em lei, sem dados identificáveis desnecessários.",
    "A Stripe (pagamentos / Conta Digital) conserva dados segundo a política e obrigações da própria Stripe. Encerramos a ligação na nossa app, mas não controlamos o arquivo completo na Stripe.",
  ],
  stripePrivacyURL: "https://stripe.com/br/privacy",

  supportTitle: "Contacto e política",
  supportBody:
    "Para dúvidas sobre privacidade ou para exercer outros direitos LGPD, use o contacto indicado na Política de Privacidade no aplicativo ou no site.",
  privacyPolicyCta: "Política de Privacidade",
} as const;
